<template>
  <el-dialog
    title="系统日志详情"
    :visible.sync="visible"
    width="60%"
    :before-close="handleClose"
    custom-class="log-detail-dialog"
    :append-to-body="true"
  >
    <el-descriptions :column="2" border>
      <el-descriptions-item label="模块名称">{{
        logDetail.module
      }}</el-descriptions-item>
      <el-descriptions-item label="描述">{{
        logDetail.description
      }}</el-descriptions-item>
      <el-descriptions-item label="请求URL">{{
        logDetail.requestUrl
      }}</el-descriptions-item>
      <el-descriptions-item label="方法名称">{{
        logDetail.methodName
      }}</el-descriptions-item>
      <el-descriptions-item label="操作人">{{
        logDetail.operator
      }}</el-descriptions-item>
      <el-descriptions-item label="处理时间"
        >{{ logDetail.processTime }}ms</el-descriptions-item
      >
    </el-descriptions>

    <div class="log-content">
      <div class="log-section">
        <h3>请求参数</h3>
        <el-card shadow="never" class="json-card">
          <div class="json-content" @click="toggleRequestParams">
            <i
              :class="[
                'el-icon-arrow-' + (isRequestParamsExpanded ? 'down' : 'right'),
                'json-arrow',
              ]"
            ></i>
            <pre>{{
              isRequestParamsExpanded
                ? formatJson(logDetail.requestParams)
                : getCollapsedJson(logDetail.requestParams)
            }}</pre>
          </div>
        </el-card>
      </div>

      <div class="log-section">
        <h3>响应结果</h3>
        <el-card shadow="never" class="json-card">
          <div class="json-content" @click="toggleResponseResult">
            <i
              :class="[
                'el-icon-arrow-' +
                  (isResponseResultExpanded ? 'down' : 'right'),
                'json-arrow',
              ]"
            ></i>
            <pre>{{
              isResponseResultExpanded
                ? formatJson(logDetail.responseResult)
                : getCollapsedJson(logDetail.responseResult)
            }}</pre>
          </div>
        </el-card>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "SystemLogDetailDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    logDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isRequestParamsExpanded: false,
      isResponseResultExpanded: false,
    };
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      // 重置展开状态
      this.isRequestParamsExpanded = false;
      this.isResponseResultExpanded = false;
    },
    formatJson(json) {
      try {
        if (typeof json === "string") {
          json = JSON.parse(json);
        }
        return JSON.stringify(json, null, 2);
      } catch (e) {
        return json;
      }
    },
    getCollapsedJson(json) {
      try {
        if (typeof json === "string") {
          json = JSON.parse(json);
        }
        if (Array.isArray(json)) {
          return `[${json.length > 0 ? "{...}" : ""}]`;
        } else if (typeof json === "object" && json !== null) {
          return "{...}";
        }
        return json;
      } catch (e) {
        return json;
      }
    },
    toggleRequestParams() {
      this.isRequestParamsExpanded = !this.isRequestParamsExpanded;
    },
    toggleResponseResult() {
      this.isResponseResultExpanded = !this.isResponseResultExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.log-detail-dialog {
  display: flex;
  flex-direction: column;

  ::v-deep .el-dialog__body {
    flex: 1;
    overflow-y: auto;
    max-height: calc(80vh - 120px);
    padding: 20px;
  }

  .log-content {
    margin-top: 20px;

    .log-section {
      margin-bottom: 20px;

      h3 {
        margin: 0 0 10px 0;
        color: #606266;
        font-size: 16px;
      }
    }
  }

  .json-card {
    background-color: #fafafa;
    margin-top: 10px;

    .json-content {
      display: flex;
      align-items: flex-start;
      cursor: pointer;

      &:hover {
        background-color: #f5f7fa;
      }

      .json-arrow {
        margin: 10px 8px 0 0;
        color: #909399;
        font-size: 14px;
      }
    }

    pre {
      margin: 0;
      padding: 10px;
      font-family: Monaco, Menlo, Consolas, "Courier New", monospace;
      font-size: 13px;
      line-height: 1.5;
      color: #333;
      white-space: pre-wrap;
      word-wrap: break-word;
      max-height: 300px;
      overflow-y: auto;
      flex: 1;
    }
  }
}

::v-deep .el-descriptions {
  margin-bottom: 20px;

  .el-descriptions-item__label {
    width: 120px;
    background-color: #f5f7fa;
  }

  .el-descriptions-item__content {
    word-break: break-all;
  }
}
</style>
